import { render, staticRenderFns } from "./BCXIcon.vue?vue&type=template&id=3a91ee4a&scoped=true"
import script from "./BCXIcon.vue?vue&type=script&lang=ts"
export * from "./BCXIcon.vue?vue&type=script&lang=ts"
import style0 from "./BCXIcon.vue?vue&type=style&index=0&id=3a91ee4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91ee4a",
  null
  
)

export default component.exports